import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/places/usePlacesQueryKeys.ts
var t = e("places", {
	autocomplete: (e, t, n) => [
		"autocomplete",
		e,
		t ?? null,
		n ?? null
	],
	details: (e) => ["details", e],
	reverse: (e, t) => [
		"reverse",
		e.toFixed(4),
		t.toFixed(4)
	]
});
//#endregion
export { t as placesQueryKeys };
